export const transformFrontendConditionsToApiFormat = (payload) => {
  const parseConditions = (value) => {
    if (value && Object.hasOwn(value, 'wrapper')) {
      return {
        condition: value.wrapper?.[0]?.operator,
        matchers: parseConditions(value.wrapper?.[0]?.matchers),
      };
    } else if (Array.isArray(value)) {
      return value.map((e) => parseConditions(e));
    } else {
      return value;
    }
  };

  return parseConditions(payload);
};

export const transformApiConditionsToFrontendFormat = (payload) => {
  const parseConditions = (value) => {
    if (value && Object.hasOwn(value, 'condition')) {
      return {
        wrapper: [
          {
            operator: value.condition,
            matchers: parseConditions(value.matchers),
          },
        ],
      };
    } else if (Array.isArray(value)) {
      return value.map((e) => parseConditions(e));
    } else {
      return value;
    }
  };

  return parseConditions(payload);
};

export const preprocessFilter = (
  condition,
  includeInResult,
  attributes = [],
  operators = [],
  attributeValues = [],
  valuePrefix,
) => {
  const deepDeprecatedSearch = (
    condition,
    deprecatedAttributes,
    deprecatedOperators,
    deprecatedValues,
  ) => {
    let aItems = [];
    let oItems = [];
    let vItems = [];

    if (!condition) {
      return {
        dAttributes: deprecatedAttributes,
        dOperators: deprecatedOperators,
        dValues: deprecatedValues,
      };
    }

    if (Array.isArray(condition?.wrapper)) {
      condition.wrapper?.[0]?.matchers?.forEach((item) => {
        if (Array.isArray(item?.wrapper)) {
          const search = deepDeprecatedSearch(
            item,
            [...aItems, ...deprecatedAttributes],
            [...oItems, ...deprecatedOperators],
            [...vItems, ...deprecatedValues],
          );

          aItems = [...search.dAttributes];
          oItems = [...search.dOperators];
          vItems = [...search.dValues];
        } else {
          const attribute = attributes.find(
            (attribute) => attribute.id === item.type,
          );
          const operator = operators.find(
            (operator) => operator.name === item.operator,
          );

          // атрибуты

          if (!attribute) {
            const deprecated = [...aItems, ...deprecatedAttributes].find(
              (deprecated) => item.type === deprecated.id,
            );

            item._deprecated_attribute = true;

            if (!deprecated) {
              aItems.push({ ...item.saved_type, _deprecated: true });
            }
          }

          // операторы

          if (!operator) {
            const deprecated = [...oItems, ...deprecatedOperators].find(
              (deprecated) => item.operator === deprecated.name,
            );

            item._deprecated_operator = true;

            if (!deprecated) {
              oItems.push({ ...item.saved_operator, _deprecated: true });
            }
          }

          // значения атрибутов

          if (item.value?.startsWith?.(valuePrefix)) {
            const attributeValue = attributeValues?.find(
              (aValue) => aValue._restApiKey === item.value,
            );

            if (!attributeValue) {
              const deprecated = [...vItems, ...deprecatedValues].find(
                (deprecated) => item.value === deprecated._restApiKey,
              );

              item._deprecated_value = true;

              if (!deprecated) {
                vItems.push({
                  ...item.saved_attribute_value,
                  _deprecated: true,
                });
              }
            }
          }
        }
      });
    }

    return {
      dAttributes: [...deprecatedAttributes, ...aItems],
      dOperators: [...deprecatedOperators, ...oItems],
      dValues: [...deprecatedValues, ...vItems],
    };
  };

  const values = deepDeprecatedSearch(condition, [], [], []);

  return {
    wrapper: condition?.wrapper ?? [
      {
        operator: 'and',
        matchers: [],
      },
    ],
    includeInResult: includeInResult ?? true,
    deprecatedAttributes: values?.dAttributes ?? [],
    deprecatedOperators: values?.dOperators ?? [],
    deprecatedValues: values?.dValues ?? [],
  };
};